// extracted by mini-css-extract-plugin
export default {"container":"Data_container__cedFu","summary":"Data_summary__Aso1O","download":"Data_download__7DMI8"};